import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { getTranslations } from "next-intl/server";
import { FooterButtons, FooterTerm } from "@/shared/ui/molecules";
const Footer = async () => {
  const $ = _c(26);
  let t0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const t = await getTranslations();
    t11 = "pt-10 px-4 pb-[86px] w-full bg-[#F7F7F8]";
    t12 = <h2 className="fs mb-2" style={{
      "--fs": 14,
      "--lh": 16
    } as React.CSSProperties}><strong className="text-[#70737C] font-semibold">{t("commonFooter.company")}</strong></h2>;
    t7 = "fs not-italic text-[#70737C] font-medium flex flex-col gap-1 mb-6";
    t8 = {
      "--fs": 12,
      "--lh": 16
    } as React.CSSProperties;
    t9 = <span>{t("commonFooter.representative")}  {t("commonFooter.businessNumber")}</span>;
    t10 = <span>{t("commonFooter.address")}</span>;
    t0 = t("commonFooter.customerService");
    t1 = " ";
    t2 = <Link href="tel:010-4432-9325">010-4432-9325</Link>;
    t3 = " ";
    t4 = <span className="mx-1 text-[#E1E2E4]">|</span>;
    t5 = " ";
    t6 = t("commonFooter.email");
    $[0] = t0;
    $[1] = t1;
    $[2] = t10;
    $[3] = t11;
    $[4] = t12;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t0 = $[0];
    t1 = $[1];
    t10 = $[2];
    t11 = $[3];
    t12 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <address className={t7} style={t8}>{t9}{t10}<span>{t0}{t1}{t2}{t3}{t4}{t5}{t6} <Link href="mailto:cs@legalcare.ai">cs@legalcare.ai</Link></span></address>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      "--fs": 12,
      "--lh": 16
    };
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <h3 className="fs mb-2 text-[#46474C] font-semibold" style={t14 as React.CSSProperties}>리뷰드 신뢰 안내</h3>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      "--fs": 12,
      "--lh": 16
    };
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <nav aria-label={"\uB9AC\uBDF0\uB4DC \uC2E0\uB8B0 \uC548\uB0B4"} className="mb-6">{t15}<ul className="fs flex flex-col items-start gap-1 text-[#46474C] font-medium underline-offset-[3px]" style={t16 as React.CSSProperties}><li><Link href="/ko/about" className="underline">회사·서비스 소개</Link></li><li><Link href="/ko/methodology" className="underline">병원 데이터 방법론</Link></li><li><Link href="/ko/corrections" className="underline">정정·이의제기</Link></li></ul></nav>;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      "--fs": 12,
      "--lh": 16
    };
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <h3 className="fs mb-2 text-[#46474C] font-semibold" style={t18 as React.CSSProperties}>지역별 병원 찾기</h3>;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      "--fs": 12,
      "--lh": 16
    };
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  let t22;
  let t23;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <nav aria-label={"\uC9C0\uC5ED\uBCC4 \uBCD1\uC6D0 \uCC3E\uAE30"} className="mb-6">{t19}<ul className="fs flex flex-col items-start gap-1 text-[#46474C] font-medium underline-offset-[3px]" style={t20 as React.CSSProperties}><li><Link href="/ko/hospitals" className="underline">전국 병원 찾기</Link></li><li><Link href="/ko/hospitals/17" className="underline">서울 강남/서초 병원 찾기</Link></li></ul></nav>;
    t22 = <FooterTerm />;
    t23 = <FooterButtons />;
    $[21] = t21;
    $[22] = t22;
    $[23] = t23;
  } else {
    t21 = $[21];
    t22 = $[22];
    t23 = $[23];
  }
  let t24;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = {
      "--fs": 12,
      "--lh": 16
    };
    $[24] = t24;
  } else {
    t24 = $[24];
  }
  let t25;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <footer className={t11}>{t12}{t13}{t17}{t21}{t22}{t23}<p className="fs text-[#70737C] font-medium" style={t24 as React.CSSProperties}>Copyright © LEGALCARE All rights reserved.</p></footer>;
    $[25] = t25;
  } else {
    t25 = $[25];
  }
  return t25;
};
export default Footer;